import React, { useEffect, useContext } from 'react';
import { getRelease } from '../api/releases';
import { apiGetOperationsForRelease } from '../api/operations';
import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useParams, useNavigate } from 'react-router-dom';
import ReleaseOperationsList from '../components/operations/ReleaseOperationsList';
import ReleaseStatusMap from '../components/overview/ReleaseStatusMap';
import ReleaseMetadata from '../components/releases/ReleaseMetadata';
import ActionsForRelease from '../components/releases/ActionsForRelease';
import AUTList from '../components/auts/AutList';
import ReleaseBranchDetail from './ReleaseBranchDetail';
import { WebSocketContext } from '../api/socket';

export default function ReleaseDetail(props) {
    const { user } = props
    const { version } = useParams();
    const navigate = useNavigate();
    const ws = useContext(WebSocketContext);
    const [data, setData] = React.useState({ loaded: false, release: {}, error: null });
    const [ops, setOps] = React.useState({ loaded: false, operations: [] });

    useEffect(() => {
        if (!data.loaded) {
            reloadData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    useEffect(() => {
        if (ws === null) {
            return;
        }
        ws.on('operation_update', onWsOperationUpdate);
        ws.on('release_update', onWSReleaseUpdate);
        return () => {
            ws.off('operation_update');
            ws.off('release_update');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ws]);

    const reloadData = () => {
        getRelease(version).then((r) => {
            setData({ loaded: true, release: r.release });
        }).catch((e) => {
            setData({ loaded: true, release: {}, error: e });
        });
        apiGetOperationsForRelease(version).then((r) => {
            setOps({ loaded: true, operations: r.operations });
        }).catch((e) => {
            setOps({ loaded: true, operations: [], error: e });
        });
    };

    const onWsOperationUpdate = (update) => {
        let op = update.operation;
        if (op.metadata.version !== version) {
            return;
        }

        setOps(state_ops => {
            let ops = [...state_ops.operations];
            let idx = ops.findIndex((o) => o.uuid === op.uuid);
            if (idx === -1) {
                ops.push(op);
            } else {
                ops[idx] = op;
            }
            return { loaded: true, operations: ops };
        }
        );
    };

    const onWSReleaseUpdate = (update) => {
        let release = update.release;

        if (release.version !== version) {
            return;
        }

        setData({ loaded: true, release: release });
    }

    let is_branch = !!data.release.branch_version;

    if (is_branch) {
        return <ReleaseBranchDetail data={data} reloadData={reloadData} navigate={navigate} />
    }

    return (
        <Grid container spacing={4} justifyContent={"center"}>
            <Grid size={{ xs: 12, md: 9 }}>
                <Paper sx={{ p: 2, minHeight: 183 }}>
                    <Typography variant="h3" mb={2}>Release {data.release.version}</Typography>
                    <ReleaseStatusMap status={data.release.status} release_date={data.release.release_date} />
                    <ReleaseMetadata release={data.release} />
                </Paper>
            </Grid>

            <Grid size={{ xs: 12, md: 3 }}>
                <Paper sx={{ p: 2, minHeight: 183 }}>
                    <Typography variant="h3" mb={2}>Actions</Typography>
                    <ActionsForRelease release={data.release} reloadData={reloadData} user={user} />
                </Paper>
            </Grid>
            {data.release.build_status !== undefined && data.release.build_status.testing !== undefined &&
            <Grid size={12}>
                <Paper
                    sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'stretch',
                        minHeight: 183,
                    }}
                    >
                    <Typography variant="h3">Tests</Typography>
                    <AUTList auts={data.release.build_status.testing} />
                </Paper>
            </Grid>
            }
            <Grid size={12}>
                <Paper
                    sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'stretch',
                        minHeight: 183,
                    }}
                >
                    <Typography variant="h3">Operations</Typography>
                    <ReleaseOperationsList operations={ops.operations} user={user} loaded={ops.loaded} onOpClick={(op) => { navigate(`/ops/${op.uuid}`) }} />
                </Paper>
            </Grid>
        </Grid>
    )
}
